import SuspectDailyActivities from './SuspectDailyActivities';
export default SuspectDailyActivities;
